import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { HomeVideo, Home, Festival } from './App';
import { Tickets, LineUp, Media, About, FAQ } from './App';
import { ContactUs, Sponsors, Terms } from './App';

import { I18nProvider } from '@lingui/react';
import { i18n } from '@lingui/core';
import { messages as enMessages } from './locales/en/messages';
import { messages as frMessages } from './locales/fr/messages';


// Load translations
i18n.load({
  en: enMessages,
  fr: frMessages,
});
i18n.activate('fr'); // Set default language

// Function to handle language switching
const toggleLanguage = () => {
  const newLang = i18n.locale === 'fr' ? 'en' : 'fr';
  i18n.activate(newLang);

  // Update the button text
  const translateButton = document.getElementById('language-btn');
  if (translateButton) {
    translateButton.textContent = newLang === 'fr' ? 'EN' : 'FR';
  }
};

// Add event listener to the button
const translateButton = document.getElementById('translate-btn');
if (translateButton) {
  translateButton.addEventListener('click', toggleLanguage);
}

// Clean up event listener on unmount
const cleanup = () => {
  if (translateButton) {
    translateButton.removeEventListener('click', toggleLanguage);
  }
};

// Clean up on unmount
window.addEventListener('unload', cleanup);





const homevideo_app = ReactDOM.createRoot(document.getElementById('homevideo_app'));
homevideo_app.render(
  <React.StrictMode>
    <HomeVideo />
  </React.StrictMode>
);

const home_app = ReactDOM.createRoot(document.getElementById('home_app'));
home_app.render(
  <React.StrictMode>
    <I18nProvider i18n={i18n}>
      <Home />
    </I18nProvider>
  </React.StrictMode>
);

const festival_app = ReactDOM.createRoot(document.getElementById('festival_app'));
festival_app.render(
  <React.StrictMode>
    <I18nProvider i18n={i18n}>
      <Festival />
    </I18nProvider>
  </React.StrictMode>
);

const tickets_app = ReactDOM.createRoot(document.getElementById('tickets_app'));
tickets_app.render(
  <React.StrictMode>
    <I18nProvider i18n={i18n}>
      <Tickets />
    </I18nProvider>
  </React.StrictMode>
);

const lineup_app = ReactDOM.createRoot(document.getElementById('lineup_app'));
lineup_app.render(
  <React.StrictMode>
    <I18nProvider i18n={i18n}>
      <LineUp />
    </I18nProvider>
  </React.StrictMode>
);

const media_app = ReactDOM.createRoot(document.getElementById('media_app'));
media_app.render(
  <React.StrictMode>
    <I18nProvider i18n={i18n}>
      <Media />
    </I18nProvider>
  </React.StrictMode>
);

const about_app = ReactDOM.createRoot(document.getElementById('about_app'));
about_app.render(
  <React.StrictMode>
    <I18nProvider i18n={i18n}>
      <About />
    </I18nProvider>
  </React.StrictMode>
);

const faq_app = ReactDOM.createRoot(document.getElementById('faq_app'));
faq_app.render(
  <React.StrictMode>
    <I18nProvider i18n={i18n}>
      <FAQ />
    </I18nProvider>
  </React.StrictMode>
);

const contact_app = ReactDOM.createRoot(document.getElementById('contact_app'));
contact_app.render(
  <React.StrictMode>
    <I18nProvider i18n={i18n}>
      <ContactUs />
    </I18nProvider>
  </React.StrictMode>
);

const sponsors_app = ReactDOM.createRoot(document.getElementById('sponsors_app'));
sponsors_app.render(
  <React.StrictMode>
    <I18nProvider i18n={i18n}>
      <Sponsors />
    </I18nProvider>
  </React.StrictMode>
);

const terms_app = ReactDOM.createRoot(document.getElementById('terms_app'));
terms_app.render(
  <React.StrictMode>
    <I18nProvider i18n={i18n}>
      <Terms />
    </I18nProvider>
  </React.StrictMode>
);
